<template>
  <div class="column full-height">
    <div class="row justify-center">
      <h4 class="text-weight-bold full-width text-center text-grey-10">
        {{ header }}
      </h4>
      <p class="full-width text-center q-mt-md">
        {{ body }}
      </p>
      <div class="full-width q-mt-xl">
        <SAISelect
          :disable="saving"
          :loading="loading"
          class="col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-4"
          placeholder="Select your company"
          :value="selectedOrganisation"
          :options="userOrganisations"
          :error="error"
          @input="$emit('update:organisation', $event)"
        />
      </div>
    </div>
    <QSpace />
    <div class="row justify-center q-mt-lg full-width">
      <SAIBtn
        :disable="loading || saving"
        :loading="saving"
        :label="nextLabel"
        icon-right="eva-arrow-forward-outline"
        :large="true"
        no-caps
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { QSpace } from 'quasar';
import SAIBtn from '../../atom/sai-btn';
import SAISelect from '../../atom/sai-select';

export default {
  name: 'SaiUserProfileStepOrganisation',
  props: {
    header: {
      type: String,
      default: 'We found you!'
    },
    body: {
      type: String,
      default:
        'To help us link you to the correct company, please select the company you are part of'
    },
    nextLabel: {
      type: String,
      default: 'Next'
    },
    loading: Boolean,
    saving: Boolean,
    error: Boolean,
    selectedOrganisation: {
      type: Object,
      default: () => ({})
    },
    userOrganisations: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SAIBtn,
    SAISelect,
    QSpace
  }
};
</script>
